import { APP_URLS, MESSAGE_FOR_NOT_ALLOWED_SITE, USER_ID_IN_COOKIE_KEY } from "./../../constants/appConstants";
import { loginAPI } from "../../apiRequests/auth/login";
import { msLoginAPI } from "../../apiRequests/auth/msLogin";
import { logoutAPI } from "../../apiRequests/auth/logout";
import { verifyCurrentSessionAPI } from "../../apiRequests/auth/verifyCurrentSession";
import { AppThunk } from "../store";
import { setAdminEventsUrl, setIsLoading, setLoginState } from "./auth-reducer";
import { setCookieValue } from "../../utils/commonUtils";
import { clearRedirectPath, consumeRedirectPath, getCurrentPath, saveRedirectPath } from "../../utils/redirectUtils";
import { toast } from "react-toastify";

export const loginThunk =
    (authorizationCode: string, navigate: (url: string) => void): AppThunk =>
    async (dispatch) => {
        try {
            dispatch(setIsLoading(true));
            const loginData = await loginAPI(authorizationCode);
            dispatch(setLoginState(true));
            setCookieValue(USER_ID_IN_COOKIE_KEY, loginData.userId);
            navigate(consumeRedirectPath() ?? `../${APP_URLS.DASHBOARD}`);
        } catch (error) {
            dispatch(setLoginState(false));
            navigate(`../${APP_URLS.SIGN_IN}`);
            toast.error(MESSAGE_FOR_NOT_ALLOWED_SITE, {
                position: "top-right",
                autoClose: 100000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "light",
            });
        } finally {
            dispatch(setIsLoading(false));
        }
    };

export const msLoginThunk =
    (authorizationCode: string, navigate: (url: string) => void): AppThunk =>
    async (dispatch) => {
        try {
            dispatch(setIsLoading(true));
            await msLoginAPI(authorizationCode);
            dispatch(setLoginState(true));
            navigate(consumeRedirectPath() ?? `../${APP_URLS.DASHBOARD}`);
        } catch (error) {
            dispatch(setLoginState(false));
            navigate(`../${APP_URLS.SIGN_IN}`);
            toast.error(MESSAGE_FOR_NOT_ALLOWED_SITE, {
                position: "top-right",
                autoClose: 100000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "light",
            });
        } finally {
            dispatch(setIsLoading(false));
        }
    };

export const logoutThunk =
    (navigate: (url: string) => void): AppThunk =>
    async (dispatch) => {
        try {
            dispatch(setIsLoading(true));
            await logoutAPI();
            clearRedirectPath();
            dispatch(setLoginState(false));
            navigate(`../${APP_URLS.SIGN_IN}`);
        } catch (error) {
        } finally {
            dispatch(setIsLoading(false));
        }
    };

export const verifySessionThunk =
    (navigate: (url: string) => void): AppThunk =>
    async (dispatch) => {
        try {
            const res = await verifyCurrentSessionAPI();
            dispatch(setLoginState(true));
            dispatch(setAdminEventsUrl(res?.adminEventsUrl));
        } catch (error) {
            dispatch(setLoginState(false));
            dispatch(setAdminEventsUrl(null));
            // Remember where the user was so login can bring them back (e.g. "/capa-management/2026-Q3").
            saveRedirectPath(getCurrentPath());
            navigate(`../${APP_URLS.SIGN_IN}`);
        }
        dispatch(setIsLoading(false));
    };
